const segToMin = (segundos) => {
  let segInt = parseInt(segundos, 10);

  return segInt = Math.floor(segInt / 60);
}

export default segToMin;
